import { ApiQuery } from "../../types";

// // // //

/**
 * getJavaScriptRequest
 * Build JavaScript example code for api.rwa.xyz API request
 */
export function getJavaScriptRequest(props: {
    query?: ApiQuery;
    baseUrl: string;
}) {
    const { query, baseUrl } = props;

    if (query === undefined) {
        return `const axios = require('axios');

// Define your API key (see https://app.rwa.xyz/tools/api/api-keys)
const api_key = "YOUR_API_KEY_HERE";

// make a GET request to the API endpoint, passing query parameters
axios.get("${baseUrl}", {
    headers: {
        "Authorization": \`Bearer \${api_key}\`
    }
})
.then(response => {
    // do something with the data
    console.log(response.data);
})
.catch(error => {
    // handle error
    console.error(error);
});
`;
    }

    return `const axios = require('axios');

// Define your API key (see https://app.rwa.xyz/tools/api/api-keys)
const api_key = "YOUR_API_KEY_HERE";

// Define your API query
const myQuery = ${JSON.stringify(query, null, 4)};

// make a GET request to the API endpoint, passing query parameters
axios.get("${baseUrl}", {
    headers: {
        "Authorization": \`Bearer \${api_key}\`
    },
    params: {
        query: JSON.stringify(myQuery),
    },
})
.then(response => {
    // do something with the data
    console.log(response.data);
})
.catch(error => {
    // handle error
    console.error(error);
});
`;
}

/**
 * getCurlRequest
 * Build cURL example code for api.rwa.xyz API request
 */
export function getCurlRequest(props: { query?: ApiQuery; baseUrl: string }) {
    const { query, baseUrl } = props;

    if (query === undefined) {
        return `
curl "${baseUrl}" \\
  -H "Authorization: Bearer YOUR_API_KEY_HERE"
`;
    }

    // NOTE - the query is single-quoted so its double quotes reach curl intact.
    // Any single quotes in the query itself have to close, escape, and reopen
    // that quoting - i.e. ' -> '\''
    const queryJson = JSON.stringify(query).replace(/'/g, `'\\''`);

    return `
curl -G "${baseUrl}" \\
  -H "Authorization: Bearer YOUR_API_KEY_HERE" \\
  --data-urlencode 'query=${queryJson}'
`;
}

/**
 * getPythonRequest
 * Build Python example code for api.rwa.xyz API request
 */
export function getPythonRequest(props: { query?: ApiQuery; baseUrl: string }) {
    const { query, baseUrl } = props;

    if (query === undefined) {
        return `
import json
import requests

# Define your API key (see https://app.rwa.xyz/tools/api/api-keys)
api_key = "YOUR_API_KEY_HERE"

# Make a GET request to the API endpoint, passing query parameters and authorization header
response = requests.get(
    "${baseUrl}",
    headers={
        "Authorization": f"Bearer {api_key}"
    }
)

# convert the response JSON data to a Python object and store in a variable
data = response.json()
print(data)
`;
    }

    return `
import json
import requests

# Define your API key (see https://app.rwa.xyz/tools/api/api-keys)
api_key = "YOUR_API_KEY_HERE"

# Define your API query
myQuery = json.dumps(${JSON.stringify(query, null, 2)
        .replace(/\btrue\b/g, "True")
        .replace(/\bfalse\b/g, "False")})

# Make a GET request to the API endpoint, passing query parameters and authorization header
response = requests.get(
    "${baseUrl}",
    params={
        "query": myQuery
    },
    headers={
        "Authorization": f"Bearer {api_key}"
    }
)

# convert the response JSON data to a Python object and store in a variable
data = response.json()
print(data)
`;
}
